import React from 'react';
import PropTypes from 'prop-types';

import {MenuItem} from '@mui/material';
import {Dropdown} from 'views/components';

import {translate} from 'views/module';

const CallStatusDropdown = (props) => {
  const {selectedStatus, setSelectedStatus} = props;

  const statuses = Object.entries(translate('client.CallStatus'));

  const handleOptionSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedStatus(selectedOption);
    }
  };

  return (
    <Dropdown onChange={handleOptionSelect} value={selectedStatus} label={translate('client.ClientDetail.Status.Menu.Subtitles.CallStatus')}>
      {
        statuses.map(([k, v]) => {
          return (
            <MenuItem key={k} value={k}>{v.Title}</MenuItem>
          );
        })
      }
    </Dropdown>

  );
};

CallStatusDropdown.propTypes = {
  selectedStatus: PropTypes.string,
  setSelectedStatus: PropTypes.func.isRequired,
};

export default CallStatusDropdown;
